import React from 'react';
import XmasTree from './XmasTree';
const XmasTreeXS = ({ color, ...props }) => (React.createElement(XmasTree, Object.assign({ color: color, size: 16 }, props)));
XmasTreeXS.displayName = 'XmasTreeXS'; // Fix for tsc
export default XmasTreeXS;
//# sourceMappingURL=XmasTreeXS.js.map